import { createApi } from "@reduxjs/toolkit/query/react";
import { apiRequestBaseQuery } from "../../services/rtkBaseQuery";
import { getUserDetails } from "../../services/apiRequest";
import { requestType } from "../../services/requests";

// =============================================================================
// ROYAL MOMENTUM - Quick Call API
// =============================================================================

export const royalMomentumQuickCallApi = createApi({
    reducerPath: "royalMomentumQuickCallApi",
    baseQuery: apiRequestBaseQuery,
    tagTypes: ["CallStatistics", "Calls", "Call"],
    endpoints: (builder) => ({
        getCallStatistics: builder.query({
            query: () => {
                const userDetails = getUserDetails();
                return {
                    requestType: requestType.getCallStatistics,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                    },
                };
            },
            providesTags: ["CallStatistics"],
        }),

        getCalls: builder.query({
            query: (params = {}) => {
                const userDetails = getUserDetails();
                return {
                    requestType: requestType.getCalls,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        salesforce_contact_id: params.salesforceContactId || null,
                        search: params.search || null,
                        date_range: params.dateRange || null,
                        page: params.page || 1,
                        limit: params.limit || 20,
                    },
                };
            },
            providesTags: ["Calls"],
        }),

        getCallDetail: builder.query({
            query: (callUid) => {
                const userDetails = getUserDetails();
                return {
                    requestType: requestType.getCallDetail,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        call_uid: callUid,
                    },
                };
            },
            providesTags: (result, error, callUid) => [{ type: "Call", id: callUid }],
        }),

        logCall: builder.mutation({
            query: (params) => {
                const userDetails = getUserDetails();
                const data = {
                    user_uid: userDetails?.user_details?.uid,
                    salesforce_contact_id: params.salesforceContactId,
                    call_type: params.callType,
                    call_datetime: params.callDatetime,
                };
                if (params.callType === "free_text") {
                    data.call_details = params.callDetails;
                } else {
                    data.bullet_points = params.bulletPoints;
                }
                return { requestType: requestType.logCall, data };
            },
            invalidatesTags: ["Calls", "CallStatistics"],
        }),

        updateCall: builder.mutation({
            query: (params) => {
                const userDetails = getUserDetails();
                const data = {
                    user_uid: userDetails?.user_details?.uid,
                    call_uid: params.callUid,
                    call_type: params.callType,
                    call_datetime: params.callDatetime,
                };
                if (params.callType === "free_text") {
                    data.call_details = params.callDetails;
                } else {
                    data.bullet_points = params.bulletPoints;
                }
                return { requestType: requestType.updateCall, data };
            },
            invalidatesTags: (result, error, params) => [
                "Calls",
                "CallStatistics",
                { type: "Call", id: params.callUid },
            ],
        }),

        deleteCall: builder.mutation({
            query: (callUid) => {
                const userDetails = getUserDetails();
                return {
                    requestType: requestType.deleteCall,
                    data: {
                        user_uid: userDetails?.user_details?.uid,
                        call_uid: callUid,
                    },
                };
            },
            invalidatesTags: ["Calls", "CallStatistics"],
        }),
    }),
});

export const {
    useGetCallStatisticsQuery,
    useGetCallsQuery,
    useGetCallDetailQuery,
    useLogCallMutation,
    useUpdateCallMutation,
    useDeleteCallMutation,
} = royalMomentumQuickCallApi;
